// src/theme/palettes/darkPalette.js
import { colors } from '../tokens/colors';

export const darkPalette = {
  mode: 'dark',
  common: {
    white: colors.white,
    black: colors.black,
  },
  primary: {
    main: '#8B5CF6',
    light: '#A78BFA',
    dark: '#6B3CE8',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#A78BFA',
    contrastText: '#0f1724',
  },
  success: {
    main: '#90c300',
    contrastText: '#ffffff',
  },
  warning: {
    main: '#FFA726',
    contrastText: '#1f2937',
  },
  error: {
    main: '#FB2C36',
    contrastText: '#ffffff',
  },
  info: {
    main: '#2e90fa',
    contrastText: '#ffffff',
  },
  // Inverted greys: map light palette greys to darker counterparts for dark mode
  grey: {
    50: colors.grey[900],
    100: colors.grey[800],
    200: colors.grey[700],
    300: colors.grey[600],
    400: colors.grey[500],
    500: colors.grey[400],
    600: colors.grey[300],
    700: colors.grey[200],
    800: colors.grey[100],
    900: colors.grey[50],
  },
  background: {
    default: colors.grey[900],
    paper: colors.grey[800],
  },
  text: {
    primary: '#E6EEF8',
    secondary: '#B8C7D8',
    disabled: '#8B98A6',
  },
  divider: 'rgba(255,255,255,0.08)',
  action: {
    hover: 'rgba(255,255,255,0.04)',
    selected: 'rgba(255,255,255,0.06)',
    disabledBackground: 'rgba(255,255,255,0.02)',
  },
};
